import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getMyNavigationMenu } from "../../api/navigationMenuService";

function EmployeeMissionControlPage() {
    const navigate = useNavigate();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            try {
                const data = await getMyNavigationMenu();
                setItems(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error("Employee menu load failed", err);
            } finally {
                setLoading(false);
            }
        };

        load();
    }, []);

    if (loading) return <div style={{ padding: 20 }}>Loading Employee Control Center...</div>;

    return (
        <div style={{ padding: 20 }}>
            <h2>Employee Control Center</h2>

            <p style={{ color: "#666", maxWidth: 900 }}>
                Operational portal for logistics monitoring, AI recommendations,
                predictive logistics, IoT telemetry and trust assessment.
            </p>

            <div style={gridStyle}>
                {items.map((item) => (
                    <div key={item.path} style={cardStyle} onClick={() => navigate(item.path)}>
                        <div style={{ fontSize: 34 }}>{item.icon}</div>
                        <h3 style={{ marginBottom: 8 }}>{item.title}</h3>
                        <div style={categoryStyle}>{item.category}</div>
                        <p style={{ color: "#666", fontSize: 14 }}>{item.description}</p>
                        <button style={buttonStyle}>Open</button>
                    </div>
                ))}
            </div>
        </div>
    );
}

const gridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: 18,
    marginTop: 24,
};

const cardStyle = {
    background: "white",
    borderRadius: 14,
    padding: 20,
    boxShadow: "0 4px 12px rgba(0,0,0,.08)",
    cursor: "pointer",
};

const categoryStyle = {
    display: "inline-block",
    padding: "4px 8px",
    borderRadius: 8,
    background: "#eef3ff",
    color: "#1976D2",
    fontSize: 12,
    marginBottom: 8,
};

const buttonStyle = {
    marginTop: 10,
    padding: "8px 14px",
    border: "none",
    borderRadius: 8,
    background: "#1976D2",
    color: "white",
    cursor: "pointer",
};

export default EmployeeMissionControlPage;